import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames/bind'
import ErrorSyncSummary from '../../errorSyncSummary'
import ErrorAsyncSummary from '../../errorAsyncSummary'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

class FormHeader extends Component {
  state = {
    forceToggle: true,
  }

  static propTypes = {
    formSyncErrors: PropTypes.object,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
    asyncError: PropTypes.string,
    title: PropTypes.node,
    errorToggle: PropTypes.bool,
  }

  static defaultProps = {
    formSyncErrors: {},
    submitFailed: false,
    invalid: false,
    asyncError: '',
    title: '',
  }

  constructor(props) {
    super(props)
    this.className = cx(this.className, 'form')
  }

  componentDidUpdate(prevProps, prevState) {
    /**
     * Here the only time we don't force toggle to be true is when it's we're going from either
     * a sync error to sync error, or an async error to async error, or if not "currently failed" and not "failed before"
     * All other cases we'll just force error to show.  This will allow for the pulse effect when
     * you click the Submit button and there's already an error showing to emphasize to the user that there's
     * still an issue.
     */
    let forceToggle = true
    if (
      (this.props.asyncError && prevProps.asyncError) ||
      (this.props.invalid &&
        !_.isEmpty(this.props.formSyncErrors) &&
        prevProps.invalid &&
        !_.isEmpty(prevProps.formSyncErrors) &&
        (!this.props.submitFailed || prevProps.submitFailed))
    ) {
      forceToggle = false
    }

    // only set when necessary to avoid infinte loop
    if (this.state.forceToggle !== forceToggle) {
      this.setState({ forceToggle }) // eslint-disable-line
    }
  }

  render() {
    const {
      formSyncErrors,
      submitFailed,
      invalid,
      asyncError,
      errorToggle,
      title,
    } = this.props
    const hasErrors =
      submitFailed && (!!asyncError || (invalid && !_.isEmpty(formSyncErrors)))
    const toggle = this.state.forceToggle || errorToggle

    return (
      (hasErrors || !!title) && (
        <div className={cx('form-header')}>
          {title && (
            <h2 className={cx('title')} data-elm-id='form_title'>
              {title}
            </h2>
          )}

          <ErrorSyncSummary
            submitFailed={submitFailed}
            invalid={invalid}
            formSyncErrors={formSyncErrors}
            errorToggle={toggle}
          />

          <ErrorAsyncSummary
            submitFailed={submitFailed}
            error={asyncError}
            errorToggle={toggle}
          />
        </div>
      )
    )
  }
}

export default FormHeader
